import React from 'react';

import { useRadio } from '@react-aria/radio';
import type { AriaRadioProps } from '@react-aria/radio';
import { mergeProps } from '@react-aria/utils';

import { ClickRadioContext } from '../field-radio-group';

export interface IProps extends AriaRadioProps {
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
}

const ClickRadioButton: React.FC<IProps> = (props) => {
  const { children, inputProps, labelProps } = props;

  const state = React.useContext(ClickRadioContext);

  const ref = React.createRef<HTMLInputElement>();

  const radio = useRadio(props, state!, ref);

  return (
    <label
      {...mergeProps(labelProps ?? {}, {
        className: labelProps?.className ?? 'block text-base pt-1 pb-1'
      })}
    >
      <input {...mergeProps(radio.inputProps, inputProps ?? {}, { className: 'mr-2' })} ref={ref} />
      {children}
    </label>
  );
};

export default ClickRadioButton;
